var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-pop-card"},[_c('div',{staticClass:"pop-card-title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }